<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
    <div class="top">
        <a [routerLink]="backLink">
            <h3>Tetris /</h3>
            <div class="breadcrumb">
                <mat-icon svgIcon="arrow back"></mat-icon>
                <h2>{{ isEditMode ? (exercise.name || 'Editar ejercicio') : 'Añadir ejercicio' }}</h2>
            </div>
        </a>
    </div>
</div>

<div class="content form">
    <form [formGroup]="exerciseForm">
        <h4>Nombre del ejercicio:</h4>
        <mat-form-field appearance="outline" id="title-form-field">
            <input type="text" matInput placeholder="Nombre del ejercicio" formControlName="name">
            @if (exerciseForm.get('name')?.invalid && exerciseForm.get('name')?.touched) {
            <mat-error>
                El nombre es requerido
            </mat-error>
            }
        </mat-form-field>

        <h4>Año:</h4>
        <div class="form-row">
            <mat-form-field appearance="outline">
                <input type="number" matInput placeholder="Año" formControlName="year" min="2000" max="2100">
                @if (exerciseForm.get('year')?.invalid && exerciseForm.get('year')?.touched) {
                <mat-error>
                    @if (exerciseForm.get('year')?.hasError('required')) {
                    El año es requerido
                    }
                    @if (exerciseForm.get('year')?.hasError('min') || exerciseForm.get('year')?.hasError('max')) {
                    El año debe estar entre 2000 y 2100
                    }
                </mat-error>
                }
            </mat-form-field>
        </div>

        <div class="exercise-dates">
            <div>
                <h4>Fecha ejercicio:</h4>
                <div class="form-row">
                    <mat-form-field appearance="outline" style="margin-right: 10px;">
                        <mat-label>Fecha de inicio</mat-label>
                        <input matInput [matDatepicker]="startPicker" formControlName="start_date">
                        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                        @if (exerciseForm.get('start_date')?.invalid && exerciseForm.get('start_date')?.touched) {
                        <mat-error>
                            La fecha de inicio es requerida
                        </mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 50%;">
                        <mat-label>Fecha de fin</mat-label>
                        <input matInput [matDatepicker]="endPicker" formControlName="end_date">
                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endPicker></mat-datepicker>
                        @if (exerciseForm.get('end_date')?.invalid && exerciseForm.get('end_date')?.touched) {
                        <mat-error>
                            La fecha de fin es requerida
                        </mat-error>
                        }
                    </mat-form-field>
                </div>

                @if (dateRangeError) {
                <div class="error-message">
                    La fecha de fin debe ser posterior a la fecha de inicio
                </div>
                }
            </div>

            <div>
                <!-- Para la petición inicial, el rango desde donde se pueden solicitar -->
                <h4>Fecha petición inicial:</h4>
                <div class="form-row">
                    <mat-form-field appearance="outline" style="margin-right: 10px;">
                        <mat-label>Fecha de inicio</mat-label>
                        <input matInput [matDatepicker]="startRequestPicker" formControlName="start_request_holidays">
                        <mat-datepicker-toggle matSuffix [for]="startRequestPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startRequestPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 50%;">
                        <mat-label>Fecha de fin</mat-label>
                        <input matInput [matDatepicker]="endRequestPicker" formControlName="end_request_holidays">
                        <mat-datepicker-toggle matSuffix [for]="endRequestPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endRequestPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                @if (requestDateIncompleteError) {
                <div class="error-message">
                    Si completas una fecha, debes completar ambas fechas
                </div>
                }
                @if (requestDateRangeError) {
                <div class="error-message">
                    La fecha de fin debe ser posterior a la fecha de inicio
                </div>
                }
            </div>

            <div>
                <!-- Para el calendario de las operativas -->
                <h4>Fecha vacaciones:</h4>
                <div class="form-row">
                    <mat-form-field appearance="outline" style="margin-right: 10px;">
                        <mat-label>Fecha de inicio</mat-label>
                        <input matInput [matDatepicker]="startVacationPicker" formControlName="start_vacation_period">
                        <mat-datepicker-toggle matSuffix [for]="startVacationPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startVacationPicker></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field appearance="outline" style="width: 50%;">
                        <mat-label>Fecha de fin</mat-label>
                        <input matInput [matDatepicker]="endVacationPicker" formControlName="end_vacation_period">
                        <mat-datepicker-toggle matSuffix [for]="endVacationPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endVacationPicker></mat-datepicker>
                    </mat-form-field>
                </div>

                @if (vacationDateIncompleteError) {
                <div class="error-message">
                    Si completas una fecha, debes completar ambas fechas
                </div>
                }
                @if (vacationDateRangeError) {
                <div class="error-message">
                    La fecha de fin debe ser posterior a la fecha de inicio
                </div>
                }
            </div>
        </div>

        <div class="phase-toggles-row">
            <div class="toggle-item">
                <mat-slide-toggle formControlName="continuous_phase">Fase continua</mat-slide-toggle>
            </div>
            <div class="toggle-item">
                <mat-slide-toggle formControlName="initial_petition">Petición inicial</mat-slide-toggle>
            </div>
        </div>

        <div class="options-row">
            <mat-checkbox formControlName="active">Activo</mat-checkbox>
        </div>

        <h4>Grupos de operativas asignados:</h4>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
                class="mat-elevation-z8">

                <!-- Columna de Grupo de Operativa -->
                <ng-container matColumnDef="operativa_group">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        GRUPO DE OPERATIVA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        {{element.name}}
                    </td>
                </ng-container>

                <!-- Columna de Asignada -->
                <ng-container matColumnDef="assigned">
                    <th mat-header-cell *matHeaderCellDef>
                        ASIGNADA
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-slide-toggle [(ngModel)]="element.isAssigned" [ngModelOptions]="{standalone: true}">
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            @if (dataSource.data.length === 0) {
            <div class="no-data">
                <p>No hay grupos de operativas disponibles</p>
            </div>
            }
        </div>

        <br><br>
        <div class="buttons">
            <button mat-flat-button id="action" type="button" (click)="saveChanges()"
                [disabled]="isSubmitting || exerciseForm.invalid || dateRangeError || vacationDateRangeError || vacationDateIncompleteError || requestDateRangeError || requestDateIncompleteError">
                @if (isSubmitting) {
                {{ isEditMode ? 'Actualizando...' : 'Guardando...' }}
                } @else {
                {{ isEditMode ? 'Actualizar' : 'Guardar cambios' }}
                }
            </button>
            <button mat-flat-button id="cancel" type="button" (click)="cancel()">Cancelar</button>
        </div>
    </form>
</div>